import { render, staticRenderFns } from "./IncomeInvestigationOnboarding.vue?vue&type=template&id=a26b26aa&scoped=true&"
import script from "./IncomeInvestigationOnboarding.vue?vue&type=script&lang=js&"
export * from "./IncomeInvestigationOnboarding.vue?vue&type=script&lang=js&"
import style0 from "./IncomeInvestigationOnboarding.vue?vue&type=style&index=0&id=a26b26aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a26b26aa",
  null
  
)

export default component.exports